import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from 'react';
export var EntryGrid = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EntryGrid, _React$Component);

  function EntryGrid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EntryGrid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        compact = _this$props.compact,
        className = _this$props.className;
    return /*#__PURE__*/React.createElement("div", {
      className: "columns is-multiline " + className
    }, compact ? this.renderCompactGrid() : this.renderSpareGrid());
  };

  _proto.renderSpareGrid = function renderSpareGrid() {
    var _this$props2 = this.props,
        items = _this$props2.items,
        children = _this$props2.children;
    return items.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "column"
      }, children(item));
    });
  };

  _proto.renderCompactGrid = function renderCompactGrid() {
    var _this$props3 = this.props,
        items = _this$props3.items,
        children = _this$props3.children;
    var childrenElement = items.map(function (item) {
      return {
        id: item.id,
        elem: children(item)
      };
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "column is-one-third"
    }, childrenElement.filter(function (_item, i) {
      return i % 3 === 0;
    }).map(function (elem) {
      return /*#__PURE__*/React.createElement("div", {
        key: elem.id
      }, elem.elem);
    })), /*#__PURE__*/React.createElement("div", {
      className: "column is-one-third"
    }, childrenElement.filter(function (_item, i) {
      return i % 3 === 1;
    }).map(function (elem) {
      return /*#__PURE__*/React.createElement("div", {
        key: elem.id
      }, elem.elem);
    })), /*#__PURE__*/React.createElement("div", {
      className: "column is-one-third"
    }, childrenElement.filter(function (_item, i) {
      return i % 3 === 2;
    }).map(function (elem) {
      return /*#__PURE__*/React.createElement("div", {
        key: elem.id
      }, elem.elem);
    })));
  };

  return EntryGrid;
}(React.Component);